@if(this.opCocaVitrine && this.storeId){
    <app-mission-additional-data [operationId]="this.opCocaVitrine.id" [data]="this.additionalsDatas" [canEdit]="true" (onChangeAdditionalsDatas)="this.onChangeAdditionalsDatas($event)"/>
}

